import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import styled from 'styled-components';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SliderContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative; /* Necesario para posicionar las flechas */
  background-color: #1a1a1a; /* Fondo oscuro para transiciones */
`;

const SlideWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex !important;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  /* Fondo borroso */
  &:before {
    content: '';
    position: absolute;
    top: -5%;
    left: -5%;
    width: 110vw;
    height: 110vh;
    background-image: url(${props => props.bgImage});
    background-size: cover;
    background-position: center;
    filter: blur(15px) brightness(0.5);
    z-index: 1;
  }
`;

const SlideImage = styled.img`
  position: relative;
  z-index: 2;
  max-width: 98vw;
  max-height: 90vh;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  margin: auto;
  display: block;
`;

const StyledSlider = styled(Slider)`
  height: 100%;
  width: 100%;

  .slick-prev, .slick-next {
    z-index: 10;
    width: 45px;
    height: 45px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.6);
    }
  }

  .slick-prev {
    left: 25px;
  }

  .slick-next {
    right: 25px;
  }

  .slick-prev:before, .slick-next:before {
    color: white;
    font-size: 20px;
  }

  .slick-dots {
    bottom: 15px;
  }

  .slick-dots li button:before {
    font-size: 12px;
    color: #fff;
    opacity: 0.5;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
  }
`;

const ImageSlider = () => {
  const [slides, setSlides] = useState([]);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const url = isMobile
          ? 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders?mobile=true'
          : 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders';
        
        const response = await axios.get(url);
        setSlides(response.data);
      } catch (error) {
        console.error('Error fetching slides:', error);
      }
    };

    fetchSlides();
  }, [isMobile]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <SliderContainer>
      <StyledSlider {...settings}>
        {slides.map(slide => (
          <div key={slide.id}>
            <SlideWrapper bgImage={slide.imagen}>
              <a href={slide.link} target="_blank" rel="noopener noreferrer">
                <SlideImage src={slide.imagen} alt={slide.Slider} />
              </a>
            </SlideWrapper>
          </div>
        ))}
      </StyledSlider>
    </SliderContainer>
  );
};

export default ImageSlider;
